import {
  createTheme,
  Divider,
  styled,
  TextareaAutosize,
  Typography,
} from '@mui/material';
import { COLORS } from '../../../utils/colors';

export const useBookingModalStyles = () => {
  return {
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column', // 💡 key
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: '1rem',
      padding: '1rem',

      maxHeight: '55vh',
      minHeight: '45rem',

      width: '45rem',
      height: '100%',
      overflow: 'hidden',
    },
    confirmModal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      width: 400,
    },
    container: {
      width: '100%',
      padding: '0',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    gridButton: {
      pt: '2rem',
      flexGrow: 1,
      overflow: 'hidden',
    },
    gridDate: {
      height: '4.5rem',
      display: 'flex',
      gap: 2,
      pr: '1rem',
    },
    buttonContainer: {
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      pt: '1rem',
    },
    button: {
      borderRadius: '2rem',
      fontWeight: 400,
      whiteSpace: 'nowrap',
      textTransform: 'none',
      backgroundImage: 'none',
      fontSize: '.9375rem',
      marginRight: '0',
      padding: '.375rem 1rem',
      color: COLORS.PRIMARY,
    },
    delete: {
      padding: '0',
      margin: '0 0.5rem',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        color: 'error.main',
      },
    },
    attachments: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      justifyContent: 'flex-end',
    },
    attachmentsIcon: {
      color: 'primary.main',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    taskList: {
      display: 'flex',
      flexDirection: 'row',
      gap: '0',
      mr: 'auto',
      alignItems: 'center',
    },
    dropzone: {
      position: 'absolute',
      top: 0,
      left: 0,
      margin: '1rem',
      width: 'calc(100% - 2rem)',
      height: 'calc(100% - 2rem)',
      backgroundColor: 'rgba(255,255,255,0.8)',
      border: '2px dashed #aaa',
      borderRadius: 2,
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
    },
    file: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '1',
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
    filelist: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      maxHeight: '10rem',
      overflow: 'auto',
      width: 'calc(100% - 1rem)',
      paddingLeft: '1rem',
      paddingBottom: '1rem',
    },
    filename: {
      flex: 1,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        color: 'rgba(0, 0, 255, 0.75)',
      },
    },
    checkbox: {
      padding: '0',
      mr: '0.5rem',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    checkboxitem: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '1',
    },
    checkboxlist: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      maxHeight: '10rem',
      overflow: 'auto',
      width: 'calc(100% - 1rem)',
      paddingLeft: '1rem',
      paddingBottom: '1rem',
    },
    extra: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    close: {
      position: 'absolute',
      left: '1rem',
      top: '1rem',
    },
    buttonPrimary: {
      ml: 'auto',
      backgroundColor: COLORS.PRIMARY,
      color: '#fff',
      '&: Hover': {
        backgroundColor: COLORS.PRIMARY,
      },
    },
    title: {
      fontWeight: 800,
      fontSize: '1.1rem',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '1rem',
    },
    form: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
    },
    grid: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      mb: '2rem',
      pb: '2rem',
      borderBottom: '.0625rem solid lightgray',
      '& .MuiGrid-item': {
        padding: '0 .5rem',
      },
    },
    timePicker: {
      border: '0px solid red',
      width: '100%',
    },
    gridDescription: {
      flexGrow: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      padding: '0 1rem 1.5rem 1rem',
    },
    gridDescription2: {
      padding: '0',
      height: '100%',
      '& .MuiInputBase-root': {
        height: '100%',
        alignItems: 'flex-start',
        padding: '.5rem 0 .5rem 1rem ',
      },
      '& .MuiInputBase-input': {
        height: '100% !important',
        overflow: 'auto !important',
      },
      '& textarea': {
        padding: '0',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      height: '3rem',
      alignItems: 'center',
      pb: '2rem',
    },
    paper: {
      flex: '1 1 auto',
      padding: '2rem',
      overflowY: 'auto',
      width: '100%',
    },
    subHeading: {
      fontSize: '1REM',
      paddingBottom: '1.25rem',
      paddingLeft: '1rem',
      fontWeight: 500,
    },
    address: {
      paddingLeft: '1.6rem',
      fontSize: '1rem',
    },
    information: {
      fontSize: '1rem',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 400,
      pt: '.5rem',
      '& .MuiTypography-root': {
        fontSize: '1rem',
        marginLeft: '0.6rem',

        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        flex: 1,
        minWidth: 0,
      },
    },

    description: {
      fontSize: '1rem',
      fontWeight: 400,
      display: 'flex',
      alignItems: 'flexStart',
    },
    taskName: {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  };
};

export const StyledDivider = styled(Divider)({
  marginBlock: '.5rem 1.5rem',
});

export const StyledTextarea = styled(TextareaAutosize)({
  width: '100%',
  padding: '.625rem',
  borderRadius: '0.75rem',
  borderColor: '#a3a3a3',
  outline: 'none',
  resize: 'vertical',
  marginTop: '.3125rem',
  fontFamily: 'montserrat',
  minHeight: '2.5rem',
  fontSize: '0.9rem',
});

export const StyledSectionHeader = styled(Typography)({
  fontSize: '1rem',
});
